import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@app/shared/utils/common';

const textareaVariants = cva(
  'resize-none text-base font-semibold leading-[20px] shadow outline-none scrollbar-hide',
  {
    variants: {
      variant: {
        default: 'bg-secondary',
        'dark-blue': 'bg-card',
        white: 'bg-white',
      },
      size: {
        default: 'w-full h-[114px] px-5 py-3.5 rounded-lg',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);

interface TextareaProps
  extends
    Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, 'size'>,
    VariantProps<typeof textareaVariants> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, variant, size, ...props }, ref) => {
    return (
      <textarea
        className={cn(textareaVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    );
  }
);
Textarea.displayName = 'Textarea';

export { Textarea };
